import { DrawerScreenProps } from '@react-navigation/drawer'
import React from 'react'
import DepositCheck from '../DepositCheck'

export const MakeDepositCheck = ({ navigation }: DrawerScreenProps<any>) => {
  return (
    <DepositCheck navigate={() => navigation.navigate('MainTabs', { screen: 'businessAccount' })} />
  )
}
